import { useState, useEffect, Fragment } from "react";
import dynamic from "next/dynamic";
import parse from "html-react-parser";
import { dehydrate, QueryClient, useQuery } from '@tanstack/react-query';

import { getQueryFn, queryKeyManager } from "../../utils/api/queryFunction";
import queryConfig from "../../utils/api/queryConfig";
import { hasProperty } from "../../utils/validate";
import { RegularIcon } from "../../components/Shared/Icons/regular";

const SEO = dynamic(() => import("../../components/Shared/SEO"));
//Get page builder
const ProductLayout = dynamic(() => import("../../components/Layout/ProductLayout"));
const SmallBanner = dynamic(() => import("../../components/Shared/Banners/SmallBanner"));
const FormBuilder = dynamic(import("../../components/Shared/FormBuilder"));

const endpoint = "contact-us";

const ContactUSPage = (props) => {
	const { token } = props;
	const { isLoading, isError, data } = useQuery({
		queryKey: queryKeyManager(["contact-us"], [token]),
		queryFn: () => getQueryFn(`${endpoint}`, token),
		...queryConfig
	})

	if (isLoading) {
		return <span />
	}

	if (hasProperty(data, 'error') || isError) {
		return <Error error={data.error} errorCode={data.error.code} />
	}

	const [formData, setFormData] = useState();

	useEffect(() => {
		async function getFormData() {
			if (hasProperty(data, "form") && data.form != null && data.form.handle) {
				let formResponse = await getQueryFn(`form/${data.form.handle}`);
				setFormData(formResponse);
			}
		}
		getFormData();
	}, [data]);

	const submitData = (success) => {
		if (success) {
			window.location.href = "/contact-us/thank-you";
		} else {
			alert("oops");
		}
	};

	return (
		<Fragment>
			<SEO seo={data.seo} />
			<ProductLayout
				nav={data.nav.header.links}
				logo={data.nav.header.logos.general}
				footer={data.nav.footer}
			>
				<SmallBanner banner={data.banner} />
				<div className="customContainer contactUs">
					<div className="row">
						<div className="col s12">
							<h2>{data.introTitle}</h2>
						</div>
						<div className="col s12 m12 l8">
							{parse(data.introDescription)}
						</div>
					</div>
					<div className="row customerCare">
						<div className="col s12">
							<h3>Customer Support</h3>
						</div>
						<div className="col s12 link">
							<a
								href={`tel:${data.contactUsNumber}`}
								title="Contact Us - Number"
							>
								<RegularIcon icon={{ icon: "phone" }} />
								{data.contactUsNumber}
							</a>
						</div>
						<div className="col s12 link valign-wrapper">
							<a
								href={`mailto:${data.contactUsEmail}`}
								title="Contact Us - Email"
							>
								<RegularIcon icon={{ icon: "envelope" }} />
								{data.contactUsEmail}
							</a>
						</div>
					</div>
					{formData && (
						<FormBuilder
							formData={formData}
							handleSubmit={submitData}
						/>
					)}
				</div>
			</ProductLayout>
		</Fragment>
	);
};

ContactUSPage.getInitialProps = async (ctx) => {
	const queryClient = new QueryClient();
	const { token } = ctx.query;
	await queryClient.prefetchQuery({
		queryKey: queryKeyManager(["contact-us"], [token]),
		queryFn: () => getQueryFn(`${endpoint}`, token),
		...queryConfig
	});
	return {
		token: token,
		dehydratedState: dehydrate(queryClient)
	};
};

export default ContactUSPage;